var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"loader",staticClass:"vx-spinner vs-con-loading__container loader",class:{ inactive: !_vm.active },style:(_vm.styles)})
}
var staticRenderFns = []

export { render, staticRenderFns }